export default __webpack_public_path__ + "static/media/botoncarga.dc18ea15.png";